import { FilterConfig } from 'src/model/filter';
import { NetworkTraffic } from 'src/dtos/netwotk-traffic.dto';
import { useStores } from '@src/components/store';

const ALL_AI_APPS = 'All AI apps';

export const useNetworkTrafficFiltersConfig = (): FilterConfig<NetworkTraffic> => {
    const {customerStore} = useStores();
    const isPremium = customerStore.isPremium;

    return {
        localStorageKey: 'networkTrafficFilter',
        radioButtons: {
            defaultSelectionIndex: 0,
            options: isPremium ? [
                {label: 'All', filterFn: (reportRow: NetworkTraffic) => reportRow.application !== ALL_AI_APPS},
                {label: 'AI Defense', filterFn: (reportRow: NetworkTraffic) => reportRow.aiDefense},
            ] : []
        },
        searchBox: {placeholder: 'Search', byFields: ['application']}
    };
};